<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    class=""
  >
    <div class="flex flex-col pb-5 items-center">
      <div class="flex justify-center mt-5"><check-mark-icon /></div>
      <p class="text-xl font-bold my-4">Swap Successful</p>
      <p
        style="word-break: normal"
        class="mb-4 text-center font-normal text-sm"
      >
        You swapped
        <span class="font-bold">
          {{
            parseMoneyAll(swapDetails.amount, swapDetails.fromCurrency)
          }}</span
        >
        and a total of
        <span class="font-bold">
          {{ parseMoneyAll(swapDetails.toAmount, swapDetails.toCurrency) }}
        </span>
        will be deposited to your account
      </p>
      <el-button
        class="bg-primary w-full py-3.5 mt-4 text-white rounded-md text-sm font-normal"
        @click="handleClose"
        >Okay</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import notification from '@/mixins/notification.js'
import { ParseMoneyAll } from '@/utils/helpers.js'
export default {
  mixins: [notification],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
      this.getAllNotifications()
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '28%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    swapDetails () {
      return this.$store.state.transactions.swapDetails
    }
  },
  components: {
    CheckMarkIcon: () => import('@/assets/icons/CheckMarkIcon.vue')
  }
}
</script>

<style scoped></style>
